// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"e1142531","65":"34795124","130":"102f4b60","622":"aadd6d57","934":"1e982039","970":"057f8933"}[chunkId] + ".css";
};